// extracted by mini-css-extract-plugin
export default {"strat-text":"text_strat-text__LdkPq","white-text":"text_white-text__7NZJt"};